// extracted by mini-css-extract-plugin
export var link = "_sp-0";